/* =============================================
   Cart Upsell Slider — Auto Related Products
   Global refresh:  window.cartUpsellRefresh()
   ============================================= */

(function ($) {
  'use strict';

  /* ------------------------------------------
     Unwrap modal-opener before Slick clones
  ------------------------------------------ */
  function prepareSlides() {
    $('.cart-upsell-slider modal-opener').each(function () {
      $(this).replaceWith($(this).children());
    });
  }

  /* ------------------------------------------
     Fix: aria-hidden + focused descendant warning

     Slick sets aria-hidden="true" on inactive
     slides but doesn't remove tabindex from
     focusable children — AT blocks the focus
     and throws a console warning.

     After every init and slide change:
       • inactive slides → tabindex="-1" on all
         focusable children + blur if focused
       • active slide    → remove tabindex so
         natural tab order is restored
  ------------------------------------------ */
  var FOCUSABLE_SEL = 'a, button, input, select, textarea, [tabindex]';

  function updateSlideTabindex($slider) {
    $slider.find('.slick-slide').each(function () {
      var $slide     = $(this);
      var isHidden   = $slide.attr('aria-hidden') === 'true';
      var $focusable = $slide.find(FOCUSABLE_SEL);

      if (isHidden) {
        // Blur any currently focused element inside this hidden slide
        $focusable.each(function () {
          if (document.activeElement === this) this.blur();
        });
        $focusable.attr('tabindex', '-1');
      } else {
        // Active slide: restore natural tab order
        $focusable.each(function () {
          var $el = $(this);
          // Only remove tabindex if it wasn't intentionally -1 in markup
          if ($el.attr('tabindex') === '-1' && !$el.is('[data-original-tabindex]')) {
            $el.removeAttr('tabindex');
          }
        });
      }
    });
  }

  /* ------------------------------------------
     Slick init / re-init
  ------------------------------------------ */
  function initCartUpsellSlider() {
    var $slider = $('.cart-upsell-slider');
    if (!$slider.length) return;

    if ($slider[0] && $slider[0].contains(document.activeElement)) {
      document.activeElement.blur();
    }

    if ($slider.hasClass('slick-initialized')) {
      // Remove previous event binding before unslick
      $slider.off('afterChange.cartUpsell');
      $slider.slick('unslick');
    }

    prepareSlides();
    var slideCount = $slider.find('.cart-upsell-slide').length;
    // var slidesToShow;
    // if (slideCount === 1) {
    //   slidesToShow = 0.5;
    // } else if (slideCount === 2) {
    //   slidesToShow = 2;
    // } else {
    //   slidesToShow = 2.3;
    // }
    $slider.slick({
      slidesToShow: 2.3, slidesToScroll: 1, arrows: false, dots: true, autoplay: true,
      autoplaySpeed: 3000,
      speed: 420,
      pauseOnHover: true,
      infinite: false,
      adaptiveHeight: true,
      accessibility: true
    });

    // Fix aria-hidden/tabindex after init
    updateSlideTabindex($slider);

    // Fix after every slide transition
    $slider.on('afterChange.cartUpsell', function () {
      updateSlideTabindex($(this));
    });
  }

  /* ------------------------------------------
     Fetch & render recommendations
  ------------------------------------------ */
  var lastFetchedProductId = null;

  function getUpsellWrapper() {
    return $('#CartDrawer .cart-upsell-wrapper').first().length
      ? $('#CartDrawer .cart-upsell-wrapper').first()
      : $('.cart-upsell-wrapper').first();
  }

  function fetchAndRenderUpsell(productId, limit) {
    var $wrapper = getUpsellWrapper();
    var $slider  = $wrapper.find('.cart-upsell-slider');

    if (!$wrapper.length || !productId) return;

    if (lastFetchedProductId === productId && $slider.find('.cart-upsell-slide').length) {
      initCartUpsellSlider();
      return;
    }

    $slider.addClass('cart-upsell-slider--loading').html(
      '<div class="cart-upsell-placeholder"><div class="cart-upsell-placeholder__card"></div></div>'
    );

    var url = '/recommendations/products?section_id=cart-upsell&product_id='
      + productId + '&limit=' + (limit || 4) + '&intent=related';

    fetch(url)
      .then(function (resp) {
        if (!resp.ok) throw new Error('Recommendations fetch failed: ' + resp.status);
        return resp.text();
      })
      .then(function (html) {
        var doc   = new DOMParser().parseFromString(html, 'text/html');
        var $recs = $(doc).find('.cart-upsell-recs-inner');

        if (!$recs.length || $recs.find('.cart-upsell-slide').length === 0) {
          $wrapper.hide();
          return;
        }

        $slider
          .removeClass('cart-upsell-slider--loading')
          .html($recs.html());

        lastFetchedProductId = productId;
        initCartUpsellSlider();
      })
      .catch(function (err) {
        console.warn('[Cart Upsell]', err);
        $wrapper.hide();
      });
  }

  function loadUpsell(retriesLeft) {
    var attemptsLeft = typeof retriesLeft === 'number' ? retriesLeft : 0;
    var $wrapper = getUpsellWrapper();
    if (!$wrapper.length) {
      if (attemptsLeft > 0) {
        setTimeout(function () {
          loadUpsell(attemptsLeft - 1);
        }, 120);
      }
      return;
    }

    var productId = $wrapper.data('upsell-product-id');
    var limit     = $wrapper.data('upsell-limit') || 4;

    fetchAndRenderUpsell(productId, limit);
  }

  /* ------------------------------------------
     Scroll save / restore helpers
  ------------------------------------------ */
  function saveScroll() {
    var $scroll   = $('.cart-drawer .drawer__inner').first();
    var scrollTop = $scroll.length ? $scroll[0].scrollTop : 0;
    if ($scroll.length) $scroll.css('min-height', $scroll[0].offsetHeight + 'px');
    return scrollTop;
  }

  function restoreScroll(scrollTop) {
    var $scroll = $('.cart-drawer .drawer__inner').first();
    if ($scroll.length) {
      $scroll[0].scrollTop = scrollTop;
      $scroll.css('min-height', '');
    }
  }

  /* ------------------------------------------
     GLOBAL REFRESH — window.cartUpsellRefresh()

     Call from any custom cart JS after update:

       success: function(resp) {
         cartselector.renderContents(resp);
         if (typeof window.cartUpsellRefresh === 'function') {
           window.cartUpsellRefresh();
         }
       }
  ------------------------------------------ */
  window.cartUpsellRefresh = function () {
    var scrollTop = saveScroll();
    setTimeout(function () {
      restoreScroll(scrollTop);
      // Retry a few times because cart drawer HTML can be replaced async.
      loadUpsell(8);
    }, 80);
  };
  document.addEventListener('cart:drawer:refreshed', function () {
    if (typeof window.cartUpsellRefresh === 'function') {
      window.cartUpsellRefresh();
    }
  });
  /* ------------------------------------------
     Intercept /cart/*.js fetch calls

     Covers ALL cart mutations automatically:
       • qty +/-    → /cart/change.js
       • remove     → /cart/change.js (qty 0)
       • add to cart → /cart/add.js
       • custom ajax → caught too
  ------------------------------------------ */
  function interceptCartFetch() {
    if (window.__cartUpsellFetchPatched) return;
    window.__cartUpsellFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function (resource, options) {
      var url             = (typeof resource === 'string') ? resource : (resource.url || '');
      var isCartMutation  = /\/cart\/(add|change|update)\.js/.test(url);
      var promise         = originalFetch.apply(this, arguments);

      if (isCartMutation) {
        promise.then(function (response) {
          if (response.ok) {
            setTimeout(function () {
              window.cartUpsellRefresh();
            }, 120);
          }
          return response;
        }).catch(function () {});
      }

      return promise;
    };
  }

  /* ------------------------------------------
     Cart icon click — load on first open
  ------------------------------------------ */
  function bindCartOpen() {
    $(document).on('click.cartUpsellOpen', '#cart-icon-bubble', function () {
      setTimeout(function () {
        loadUpsell(5);
      }, 350);
    });
  }

  function bindCartPubSub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        window.cartUpsellRefresh();
      });
    }
  }

  function bindUpsellBlur() {
    $(document).on('click.cartUpsellBlur', '.cart-upsell-slide .quick-add__submit', function () {
      var btn = this;
      setTimeout(function () {
        btn.blur();
      }, 0);
    });
  }

  /* ------------------------------------------
     Bootstrap
  ------------------------------------------ */
  $(document).ready(function () {
    interceptCartFetch();
    bindCartOpen();
    bindCartPubSub();
    bindUpsellBlur();
    loadUpsell(2);
  });

})(jQuery);
